import { useState, useEffect } from 'react';

export const useIsDesktop = () => {
  const [isDesktop, setIsDesktop] = useState(typeof window !== 'undefined' && window ? window?.innerWidth > 767 : false);

  useEffect(() => {
    if (typeof window !== 'undefined' && window && window.innerWidth) {
      const handleResize = () => {
        setIsDesktop(window?.innerWidth > 767);
      };
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }
    return null;
  });

  return isDesktop;
}